export default '2.1.1';



// WEBPACK FOOTER //
// ./src/lib/version.js